// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"6dc1d768","599":"a460f1bc"}[chunkId] + ".chunk.js";
};